import React, {Suspense, useState} from "react";

import styles from "./microbial_sex_loops.module.css"

import MiaInterface from "./mia_interface";
import Sounds from "./microbial_sex_loops_sounds";

import * as Data from "./get_section_content"
import {AndeVisuals} from "./ande_visuals";
import {Images} from "../../AssetReferences";
import {MicrobeBackButton} from "../../components/microbeBackButton";
import {useNavigate} from "react-router-dom";
import {PageTitles, SitePages} from "../../SitePages";
import {useTitle} from "../../hooks/UseTitle";

export default function MicrobialSexLoops({})
{
    const [section, setSection] = useState(Data.HOME)
    const [currentAudio, setCurrentAudio] = useState(null);

    const navigate = useNavigate();
    useTitle(PageTitles.MicrobialSexLoops)
    
    function selectSection(id, text)
    {
        setSection(text);        
    }
    
    function handleOnPlay(audioElement)
    {
        if (audioElement) setCurrentAudio(audioElement);
    }
    
    function handleExit()
    {
        navigate(`../${SitePages.Home}`);
    }

    return (
        <>
            <div className={styles.microbialSexLoops}>

                <MicrobeBackButton 
                    image_src={Images.AndeMia1}
                    onClick={handleExit}
                    size={7}
                    left={1}
                    top={1}
                    tooltip={"Return to home page"}
                    />

                <Suspense fallback={<Loading/>}>
                    <MiaInterface section={section} currentAudio={currentAudio} buttonPressed={selectSection}/>
                    <Sounds section={section} onPlay={handleOnPlay}/>
                </Suspense>

                <br/>

                <Suspense fallback={<Loading/>}>
                    <AndeVisuals section={section}/>
                </Suspense>

            </div>
            
        </>
    )
}


function Loading()
{    
    return (<h2>loading...</h2>)
}
